module.exports = __webpack_public_path__ + "img/yfood-classic-choco.d2eec202.png";